var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevisionInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57234_17120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3076 26.575C48.4608 27.4605 53.181 31.7138 53.181 36.4779V36.5803C53.181 41.8522 47.4004 46.2627 40.2952 46.4123L37.9843 46.4611V50.2194L30.8672 43.2159L37.9843 36.2121V40.1776L40.5554 39.9476C46.4228 39.4219 50.848 35.5817 50.848 31.0146C50.848 31.0134 50.848 31.012 50.848 31.0109",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3047 33.0896C44.8705 33.5901 47.0783 34.7413 48.6368 36.293",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6951 25.3132C5.54188 24.4279 0.820312 20.1746 0.820312 15.4103V15.3079C0.820312 10.036 6.60137 5.62522 13.7075 5.47589L16.0184 5.42705V1.66846L23.1355 8.67227L16.0184 15.6761V11.7105L13.4472 11.9408C7.57991 12.4662 3.15518 16.3065 3.15518 20.8736C3.15518 20.8747 3.15518 20.8764 3.15518 20.8775",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6985 18.7988C9.13157 18.2983 6.92465 17.1469 5.36621 15.5955",
    stroke: "#FFC700",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 17.9639H36.908",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0812 44.102H14.3982C13.0417 44.102 11.9429 43.0027 11.9429 41.6466V15.2104",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0303 7.53687H39.4457C40.8011 7.53687 41.9008 8.63611 41.9008 9.99218V36.7861",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 21.1436H36.908",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 24.323H36.908",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 27.5027H36.908",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 30.6821H36.908",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.936 33.8618H27.3691",
    stroke: "#4076B4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57234_17120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 50.5375,
    fill: "currentColor",
    transform: "translate(0 0.731201)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevisionInfo);
export default __webpack_public_path__ + "static/media/revision_info.98195f113e8ed5496a3191a448ff5983.svg";
export { ForwardRef as ReactComponent };